export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Flight Instructor Ready after purchasing?',
    a: ['You receive digital access to the complete material after your purchase is completed.'],
  },
  {
    q: 'Is this an app?',
    a: [
      'No.',
      'Flight Instructor Ready is a complete digital teaching resource delivered as organized PDF material that you can open whenever you need it.',
    ],
  },
  {
    q: 'Is this a visual product or mostly text?',
    a: [
      'Flight Instructor Ready was specifically designed as a 100% visual teaching system.',
      'The material combines structured instruction with diagrams, visual sequences, examples, comparisons, checklists, instructor cues and practical teaching tools.',
    ],
  },
  {
    q: 'Does the package include videos?',
    a: ['No.', 'The package consists of digital PDF teaching resources. Videos are not included.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes.', 'Flight Instructor Ready is provided in English.'],
  },
  {
    q: 'Can I edit the material?',
    a: [
      'No.',
      'The material is delivered as ready-to-use PDF resources and is not provided in editable format.',
    ],
  },
  {
    q: 'Is it only for complete beginners?',
    a: [
      'No.',
      'The complete 6-in-1 system covers progression from beginner foundations through developing students and checkride-ready preparation.',
    ],
  },
  {
    q: "Is the system tied to one country's aviation regulations?",
    a: [
      'No.',
      'Flight Instructor Ready is designed for instructors worldwide and focuses on broadly applicable flight-training concepts and teaching structures.',
      'Aircraft-specific procedures, local regulations, official checklists, POH/AFM requirements and flight-school SOPs should always take priority where applicable.',
    ],
  },
]
